interface ApiError {
  status: number | string;
  data?: string;
}

export function getFriendlyError(
  error: ApiError,
  actionName: string,
  useReadable: boolean,
): string {
  if (!useReadable) {
    return (
      (typeof error.data === 'string' ? error.data : null) || 'Unknown error'
    );
  }

  const status = error.status;
  const raw = typeof error.data === 'string' ? error.data : '';

  if (status === 403)
    return 'You do not have permission to perform this action.';

  if (status === 400)
    return (
      raw || `${actionName} failed. Please check your inputs and try again.`
    );

  if (status === 404)
    return `${actionName} failed: the record was not found. Please refresh and try again.`;

  if (status === 500 && raw) return raw;

  if (status === 'FETCH_ERROR')
    return `${actionName} failed. Please check your connection and try again.`;

  return `${actionName} failed. Please try again.`;
}
